/** The deep-link prefixes the server writes (`support-notice.ts` `SUPPORT_NOTICE_LINK`). */
export const INBOX_LINK = { ticket: 'support.ticket/', contest: 'ride.contest/' };
/** Deep links (or link prefixes) of notices that belong to the rider app only. */
export const RIDER_ONLY_INBOX_LINKS = [INBOX_LINK.contest, 'reservation/', 'send.order.', 'food.order.'];
const idAfter = (link, prefix) => {
    if (!link.startsWith(prefix))
        return undefined;
    const id = link.slice(prefix.length).trim();
    return id !== '' && !id.includes('/') ? id : undefined;
};
/** Where a row's deep link goes; a contest only in the rider app. */
export function inboxTargetOf(deepLink, app) {
    const link = (deepLink ?? '').trim();
    const ticketId = idAfter(link, INBOX_LINK.ticket);
    if (ticketId !== undefined)
        return { kind: 'ticket', ticketId };
    const rideId = idAfter(link, INBOX_LINK.contest);
    if (rideId !== undefined && app === 'rider')
        return { kind: 'contest', rideId };
    return { kind: 'none' };
}
/** Whether a row is listed in `app` (the provider app leaves out what only the rider app can act on). */
export function inboxRowShownIn(deepLink, app) {
    if (app === 'rider')
        return true;
    const link = (deepLink ?? '').trim();
    return !RIDER_ONLY_INBOX_LINKS.some((prefix) => link.startsWith(prefix));
}
/** The inbox as `app` shows it. */
export function describeInbox(items, app) {
    const rows = items
        .filter((item) => inboxRowShownIn(item.deepLink, app))
        .map((item) => ({
        id: item.id,
        ...(item.title !== undefined && item.title.trim() !== '' ? { title: item.title } : {}),
        body: item.body,
        createdAt: item.createdAt,
        unread: item.readAt === undefined || item.readAt === null,
        target: inboxTargetOf(item.deepLink, app),
    }));
    return { rows, unread: rows.filter((r) => r.unread).length };
}
/** Whether a mark-read answer settles the row (a success, or a 404: already read elsewhere or gone). */
export function inboxMarkSettled(res) {
    return res.ok || res.error.status === 404;
}
//# sourceMappingURL=notification-inbox.js.map